module.exports = __webpack_public_path__ + "e2d5fe39f44bad69712c835b41ee9ba6.svg";